document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("contact-form");
  const statusEl = document.getElementById("contact-status");

  form.addEventListener("submit", async function (e) {
    e.preventDefault();
    statusEl.className = "z2-contact-form-response neutral";
    statusEl.textContent = "Sende Nachricht ...";

    const formData = new FormData(form);
    const payload = {
        name: formData.get("name"),
        company: formData.get("company"),
        phone: formData.get("phone"),
        email: formData.get("email"),
        subject: formData.get("subject"),
        message: formData.get("message"),
        callback: formData.get("callback") === "yes",
        privacyAccepted: formData.get("privacy") === "yes",
        website: formData.get("website")
    };

      if (payload.callback && !payload.phone) {
          statusEl.className = "z2-contact-form-response negative";
          statusEl.textContent = "Falls Rückruf gewünscht, bitte eine Telefonnummer angeben.";
      } else {
          try {
              const res = await fetch("https://mlld785bhd.execute-api.eu-central-1.amazonaws.com/contact", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify(payload)
              });

              const data = await res.json();

              if (res.ok && data.success) {
                  statusEl.className = "z2-contact-form-response positive";
                  statusEl.textContent = "Vielen Dank! Ihre Nachricht wurde erfolgreich gesendet.";
                  form.reset();
              } else {
                  statusEl.className = "z2-contact-form-response negative";
                  statusEl.textContent = data.error || "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.";
              }
          } catch (err) {
              console.error(err);
              statusEl.className = "z2-contact-form-response negative";
              statusEl.textContent = "Es ist ein Verbindungsfehler aufgetreten. Bitte versuchen Sie es später erneut.";
          }
      }
  });
});

